const configList={
    timeData:[
       {indexNo:1,selectName:"秒",val:'1'},
       {indexNo:2,selectName:"分",val:'60'},
       {indexNo:3,selectName:"时",val:'3600'},
       {indexNo:4,selectName:"天",val:'86400'},
       {indexNo:5,selectName:"周",val:'604800'}
    ],
    doorList:[
     { indexNo:1, selectName: '='}, 
     { indexNo:2, selectName: '>'},
     { indexNo:3, selectName: '<'},
     { indexNo:4, selectName: '>='}, 
     { indexNo:5, selectName: '<='}
    ],
    selectBtn:[
      {title:"近一周",val:1},
      {title:"近一月",val:2},
      {title:"近一年",val:3},
    ],
    iconList:[
       {title:"在线icon",val:"online",mak:false},
       {title:"报警icon",val:"police",mak:false},
       {title:"故障icon",val:"fault", mak:false},
       {title:"离线icon",val:"unline",mak:false}
    ],
    accountTypeList:[
        // {title:"运营", val:1,color:"#409EFF"},
        {title:"工厂", val:2,color:"#07C160"},
        {title:"代理商",val:3,color:"#FFC23F"},
        {title:"工程商",val:4,color:"#000000"},
        {title:"充电商",val:5,color:"rgb(68, 236, 175)"}
    ],
    accountTypeLists:[
      {title:"运营", val:1,color:"#409EFF"},
      {title:"工厂", val:2,color:"#07C160"},
      {title:"代理商",val:3,color:"#FFC23F"},
      {title:"工程商",val:4,color:"#000000"},
      {title:"充电商",val:5,color:"rgb(68, 236, 175)"}
    ],
    rechargeList:[
        {title:"微信",  val:1, color:"#07C160"},
        {title:"支付宝",val:2, color:"#409EFF"},
        {title:"钱包",  val:3, color:"#FFC23F"}
    ],
    rechargeListCHaong:[
      {title:"微信",  val:1, color:"#07C160"},
      {title:"支付宝",val:2, color:"#409EFF"},
      {title:"钱包余额",  val:3, color:"#FFC23F"},
      {title:"线下支付",  val:4, color:"#FFC23F"},
      {title:"平台赠送",  val:5, color:"#FFC23F"},
      {title:"钱包赠送",  val:6, color:"#FFC23F"},
  ],
    rechargeType:[
       {title:"钱包",val:1, color:"#409EFF"},
       {title:"语音",val:2, color:"#3AE2CE"},
       {title:"短信",val:3, color:"#E21627"}
    ],
    statusList:[
       {title:"充值中", val:0, color:"#409EFF"},
       {title:"成功",   val:1, color:"#3AE2CE"},
       {title:"失败",   val:2, color:"#E21627"} 
   ],
   clientList:[
       {title:"PC",       val:1, color:"#409EFF"},
       {title:"APP",      val:2, color:"#3AE2CE"},
       {title:"小程序",    val:3, color:"#07C160"} 
   ],
	sourceList:[
       {title:"小程序", val:1, color:"#409EFF"},
       {title:"App",   val:2, color:"#3AE2CE"},
      //  {title:"PC",   val:3, color:"#07C160"} 
	],
   rechargeListType:[
      {title:"线上充值",val:1, color:"#409EFF"},
      {title:"线下充值",val:2, color:"#3AE2CE"},
      {title:"赠送",val:3, color:"#07C160"},
   ],
  //  1=微信，2=支付宝，3=钱包-余额，4=线下支付，5=平台赠送，6=钱包-赠送
   payListType:[
    {title:'微信',val:1},
    {title:'支付宝',val:2},
    {title:'钱包-余额',val:3},
    {title:'线下支付',val:4},
    {title:'平台赠送',val:5},
    {title:'钱包-赠送',val:6}
   ],
   searchrechargeListType:[
      {title:"钱包-余额",val:1},
      {title:"短信",val:2},
      {title:"语音",val:3},
      {title:"设备续费",val:4},
      {title:"钱包-赠送",val:5},
   ],
   TongxinType:[
      {title:"短信",val:1,color:"#409EFF"},
      {title:"语音",val:2,color:"#07C160"}
   ],
   stateList:[
      {title:"启用",val:1,color:"#409EFF"},
      {title:"禁用",val:0,color:"#07C160"}
   ],
    appType:[
		{title:"Android",val:1,color:"#409EFF"},
		{title:"Ios",val:2,color:"#07C160"}
	],
   // DictionarList:[
   //    {title:"csq",               val:"信号强度"},
   //    {title:"imsi",              val:"IMSI"},
   //    {title:"doorStat",          val:"开门"},
   //    {title:"report_time",       val:"上报时间"},
   //    {title:"privatePhyModel",   val:"私有"},
   //    {title:"voltage",           val:"电压", unit:"V"},
   //    {title:"temperature",       val:"温度", unit:"°C"},
   //    {title:"reportTimer",       val:"上报时间"},
   //    {title:"status",            val:"状态"},
   //    {title:"policeStatus",      val:"报警状态"},
   //    {title:"concentration",     val:"浓度"},
   //    {title:"smokePolice",       val:"烟感报警"},
   //  ],
   installType:[
   	{title:"已安装",val:1,color:"#409EFF"},
   	{title:"未安装",val:0,color:"#07C160"}
   ],
   lineType:[
   	{title:"在线",val:1,color:"#409EFF"},
   	{title:"离线",val:0,color:"#07C160"}
   ],
   installersType:[
   	{title:"运营",val:1,color:"#409EFF"},
   	{title:"工厂",val:2,color:"#6ac161"},
	  {title:"代理商 ",val:3,color:"#936bc1"},
	  {title:"工程商",val:4,color:"#c1bdae"},
	  {title:"充电商",val:5,color:"#c1b25e"},
   ],
   projectList:[
   	{title:"消防",val:"1"},
    {title:"新能源",val:"2"},
    {title:"新能源-单车",val:"3"},
    {title:"新能源-汽车",val:"4"}
   ],
    modelList: [
      {
        code: "gmt",  //门磁
        list: [
          { title: "csq", val: "csq" },
          { title: "signalNumber", val: "信号强度" },
          { title: "imsi", val: "IMSI" },
          { title: "voltage", val: "电压", unit: "V" },
          { title: "temperature", val: "环境温度", unit: "°C" },
          { title: "reportTimer", val: "上报时间" },
          { title: "status", val: "状态", },  //0关门 1开门
        ]
      },
      {
        code: "dgat",  //家用燃气
        list: [
          { title: "csq", val: "csq" },
          { title: "imsi", val: "IMSI" },
          { title: "signalNumber", val: "信号强度" },
          { title: "electricityQuantity;", val: "电量", unit: "%" },
          { title: "temperature", val: "环境温度", unit: "°C" },
          { title: "reportTimer", val: "上报时间" },
          { title: "policeStatus;", val: "报警状态" },   //true报警 false正常
        ]
      },
      {
        code: "lgat",  //工业燃气
        list: [
          { title: "csq", val: "csq" },
          { title: "signalNumber", val: "信号强度" },
          { title: "concentration", val: "浓度", unit: "%" },
          { title: "imsi", val: "IMSI" },
          { title: "reportTimer", val: "上报时间" },
          { title: "privateModel", val: "私有物模型" },
        ]
      },
      {
        code: "gahft",  //4G工业主机
        list: [
          { title: "csq", val: "csq" },
          { title: "imsi", val: "IMSI" },
          { title: "signalNumber", val: "信号强度" },
          { title: "policeStatus", val: "报警状态" },   //true报警 false正常
          { title: "concentration", val: "浓度", unit: "%" },
          { title: "slaveId", val: "设备ID" },
          { title: "switchStatus", val: "开关状态", },  //true代表闭合，false代表断开
          { title: "reportTimer", val: "上报时间" },
        ]
      },
      {
        code: "sscdt", //烟感复合探测器物模型
        list: [
          { title: "csq", val: "csq" },
          { title: "imsi", val: "IMSI" },
          { title: "signalNumber", val: "信号强度" },
          { title: "voltage", val: "电压", unit: "V" },
          { title: "smokePolice", val: "烟感报警" },
          { title: "tempPolice", val: "温度报警" },
          { title: "reportTimer", val: "上报时间" },
          { title: "privateModel", val: "私有物模型" },
        ]
      },
      {
        code: "sdt", //烟感物模型
        list: [
          { title: "csq", val: "csq" },
          { title: "signalNumber", val: "信号强度" },
          { title: "voltage", val: "电压", unit: "V" },
          { title: "policeStatus;", val: "报警状态" },     //true报警 false正常
          { title: "imsi", val: "IMSI" },
          { title: "reportTimer", val: "上报时间" },
          { title: "privateModel", val: "私有物模型" },
        ]
      },
    ]
}
module.exports = {
   conText:configList
}
